module.exports = __webpack_public_path__ + "img/50-r.58d14fd9.png";